import { AxiosResponse } from 'axios';
import {
  ChangeLogEntityType,
  ChangeLogListResponse,
  ShotCountUpdateLog,
  FanucReportImportItem,
  FanucReportImportRun,
} from '../../types/mold';
import api from './client';

export const changeLogService = {
  getChangeLogs: async (
    entityType: ChangeLogEntityType,
    params: { limit?: number; offset?: number } = { limit: 10, offset: 0 },
  ): Promise<AxiosResponse<ChangeLogListResponse>> => {
    return api.get(`/change-logs/${entityType}`, { params });
  },
  getChangeLogsByEntityId: async (
    entityType: ChangeLogEntityType,
    entityId: number,
    params: { limit?: number; offset?: number } = { limit: 10, offset: 0 },
  ): Promise<AxiosResponse<ChangeLogListResponse>> => {
    return api.get(`/change-logs/${entityType}/${entityId}`, { params });
  },
};

export const moldLabelService = {
  downloadMoldLabels: async (data: {
    moldIds: number[];
  }): Promise<AxiosResponse<Blob>> => {
    return api.post('/mold-labels', data, {
      responseType: 'blob',
      headers: {
        Accept: 'application/pdf',
      },
    });
  },
};

export const reportService = {
  getShotCountReport: async (params?: {
    startDate?: string;
    endDate?: string;
  }): Promise<AxiosResponse<ShotCountUpdateLog[]>> => {
    return api.get('/analytics/shotcount-report', { params });
  },
  getFanucImportRuns: async (params?: {
    startDate?: string;
    endDate?: string;
  }): Promise<AxiosResponse<FanucReportImportRun[]>> => {
    return api.get('/analytics/fanuc-import-runs', { params });
  },
  getFanucImportItems: async (
    id: number,
    params?: { result?: string; reasonCode?: string },
  ): Promise<AxiosResponse<FanucReportImportItem[]>> => {
    return api.get(`/analytics/fanuc-import-runs/${id}/items`, { params });
  },
};

export const dashboardService = {
  executeQuery: async (
    queryId: string,
    parameters: Record<string, any> = {},
  ): Promise<AxiosResponse<{ results: any[] }>> => {
    return api.post('/analytics/dashboard-query', { queryId, parameters });
  },
};
